"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Put RGB into a string
 */
function rgbStringfy(r, g, b) {
    return "rgb(" + r + ", " + g + ", " + b + ")";
}
exports.default = rgbStringfy;
//# sourceMappingURL=rgbStringfy.js.map